import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IPageTabs } from "@models/entity-models";

@Kbo(CToken.PageTabs)
export class PageTabs extends UiObject implements IPageTabs {

    constructor(kom: KbObjectManager) {
        super(kom);
    }    

    public orientation: string; //eOrientation
    public tabStyle: string;
    public tabWidth: string;
    public customTabWidth: number;
    public iconSize: number;
    public showTabLabels: boolean;
    public backgroundColor: string;
    public backgroundShade: string;
    public selectionStyle: string;
    public selectionColor: string;
    public selectionShade: string;
    public selectionLineColor: string;
    public elevation: string;
}
